import ChartAvg from "./ChartAvg";

export default function Charts() {  
   
    return (
      <div>
            <ChartAvg/>
      </div>
    );
  }
  